import "./Angebote.module.css";
import Header from "@/reusable_sections/Header";
import HolisticApproaches from "./sections/HolisticApproaches";
import HolisticResonance from "./sections/HolisticResonance";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import TerminAnfragen from "./sections/TerminAnfragen";
import Abschluss from "@/reusable_sections/Footer";
export default function AngebotePage() {
  return <div>
      <Header />
      <HolisticApproaches />
      <HolisticResonance />
      <FrequentlyAskedQuestions />
      <TerminAnfragen />
      <Abschluss />
    </div>;
}